<template>
  <div>
    <h3 style="color:#143150"><b>{{start}}. ウェブ偽造検出 (WFDetector)</b></h3><br>
    <b-row style="padding-left:25px;">
      <b-col>
        <h4><b>{{start}}.1 概要</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.1.1. 基本情報</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Username</th>
                  <th style="background-Color:#3D63BA; text-align: center; background-Color:#f0f3f5;">{{auth.profile.username}}</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">period</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{from}} ~ {{to}}</th>
                </tr>
              </tbody>
            </table>

            <h5><b>{{start}}.1.2. 契約状況</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Status</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Total Count</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Contracted</th>
                  <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{
                      ((wmds_summary && wmds_summary.wf_detector_stauts) ? wmds_summary.wf_detector_stauts.count : 0) +
                        ((wsfinder_summary && wsfinder_summary.wf_detector_stauts) ? wsfinder_summary.wf_detector_stauts.count : 0)
                    }}
                  </th>
                </tr>
                <!-- <tr v-for="WF_5_1_2 in this.wmds_summary.wf_detector_stauts" :key="WF_5_1_2.index">
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">{{WF_5_1_2.type}}</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{WF_5_1_2.count || '0'}}</th>
                </tr> -->
              </tbody>
            </table>
            <h5><b>{{start}}.1.3. セキュリティに関わるイベントの総数</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Events</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Count</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">
                    {{wmds_summary.wf_total_number_of_security_events && wmds_summary.wf_total_number_of_security_events.type ? wmds_summary.wf_total_number_of_security_events.type.toUpperCase() : ''}}(Domain)
                  </th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{wmds_summary && wmds_summary.wf_total_number_of_security_events ? wmds_summary.wf_total_number_of_security_events.count :  0}}
                  </th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">
                    {{wsfinder_summary.wf_total_number_of_security_events && wsfinder_summary.wf_total_number_of_security_events.type ? wsfinder_summary.wf_total_number_of_security_events.type.toUpperCase() : ''}} (Server)
                  </th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{wsfinder_summary && wsfinder_summary.wf_total_number_of_security_events ? wsfinder_summary.wf_total_number_of_security_events.count : 0}}
                  </th>
                </tr>
              </tbody>
            </table>
            <h5>
              <b>
                5.1.4. WebサーバとWFDetectorの状況
                <!-- <small class="float-right">List of last 50</small> -->
              </b>
            </h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%" colspan="3">WSFinder Server</td>
                </tr>
                <tr>
                  <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</td>
                  <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Host</td>
                  <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">IP</td>
                </tr>
                <tr v-for="WF_5_1_4 in wsfinder_summary.web_server_and_wf_detector_status" :key="WF_5_1_4.index">
                  <td style="border:1px solid; text-align: center;">{{WF_5_1_4.name}}</td>
                  <td style="border:1px solid; text-align: center;">{{WF_5_1_4.host}}</td>
                  <td style="border:1px solid; text-align: center;">{{WF_5_1_4.ip}}</td>
                </tr>
                <tr v-if="wsfinder_summary.web_server_and_wf_detector_status.length < 1">
                  <td style="border:1px solid; text-align: center;">N/A</td>
                  <td style="border:1px solid; text-align: center;">N/A</td>
                  <td style="border:1px solid; text-align: center;">N/A</td>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.5. ドメインとWFDetectorの状況</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%" colspan="3">WMDS Domain</td>
                </tr>
                <tr>
                  <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</td>
                  <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">FQDN</td>
                </tr>
                <tr v-for="WF_5_1_5 in wmds_summary.domain_and_wf_detector_status" :key="WF_5_1_5.index">
                  <td style="border:1px solid; text-align: center;">{{WF_5_1_5.name}}</td>
                  <td style="border:1px solid; text-align: center;">{{WF_5_1_5.fqdn}}</td>
                </tr>
                <tr v-if="wmds_summary.domain_and_wf_detector_status.length < 1">
                  <td style="border:1px solid; text-align: center;">N/A</td>
                  <td style="border:1px solid; text-align: center;">N/A</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <h4><b>{{start}}.2 監視状況</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.2.1. 偽造検知総数（日次）</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.1.1. 偽造検知数（日次）</b></h5>
                <line-chart :chartData="WF_Daily_Detect_Total"></line-chart>
              </b-col>
            </b-row>
            <hr>
            <!-- 사이트별 또는 서버별 -->
            <h5><b>{{start}}.2.2.  個別ドメインに対する偽造検知数（日次）</b></h5>
            <b-row style="padding-left:25px;" v-for="(WF_5_2_2, wmds_wf_index) in WF_Daily_detect_domain" :key="WF_5_2_2.index">
              <b-col>
                <h5><b>{{start}}.2.2.{{wmds_wf_index + 1}} ドメイン毎の偽造検知数 ({{WF_5_2_2.fqdn}})</b></h5>
                <line-chart :chartData="WF_5_2_2.chart"></line-chart>
              </b-col>
            </b-row>
            <!-- <hr v-if="WF_Daily_detect_server.length > 0"> -->
            <b-row style="padding-left:25px;" v-for="(WF_5_2_3, wsf_wf_index) in WF_Daily_detect_server" :key="WF_5_2_3.index">
              <b-col>
                <h5><b>{{start}}.2.2.{{wsf_wf_index +  (WF_Daily_detect_domain && WF_Daily_detect_domain.length ? WF_Daily_detect_domain.length : 0) + 1}} ドメイン毎の偽造検知数 ({{WF_5_2_3.host}})</b></h5>
                <line-chart :chartData="WF_5_2_3.chart"></line-chart>
              </b-col>
            </b-row>
            <b-row style="padding-left:25px;" v-if="WF_Daily_detect_server && WF_Daily_detect_server.length < 1 && WF_Daily_detect_domain && WF_Daily_detect_domain.length < 1">
              <b-col>
              <line-chart  :chartData="DEFAULT_CHART_DATA"></line-chart>
              </b-col>
            </b-row>
            <hr>
            <h5><b>{{start}}.2.3. 偽造検知（ドメイン毎）</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.3.1. 偽造検知総数（ドメイン毎）</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">
                      <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;" rowspan="2">Domain Name / Web Server</td>
                      <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Events</td>
                    </tr>
                      <tr style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">
                      <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Detected</td>
                    </tr>
                    <!-- wmds -->
                    <tr style="border:1px solid; text-align: center;" v-for="WF_5_2_3_1 in wmds_summary.wf_total_number_per_domain" :key="WF_5_2_3_1.index">
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_1.fqdn}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_1.count ? WF_5_2_3_1.count : 0}}</td>
                    </tr>
                    <!-- wsfinder -->
                    <tr style="border:1px solid; text-align: center;" v-for="WF_5_2_3_1 in wsfinder_summary.wf_total_number_per_server" :key="WF_5_2_3_1.index">
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_1.name}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_1.count ? WF_5_2_3_1.count : 0}}</td>
                    </tr>
                    <tr style="border:1px solid; text-align: center;"
                      v-if="wmds_summary.wf_total_number_per_domain.length < 1 && wsfinder_summary.wf_total_number_per_server.length < 1"
                    >
                      <td style="border:1px solid; text-align: center;">N/A</td>
                      <td style="border:1px solid; text-align: center;">N/A</td>
                    </tr>
                  </tbody>
                </table>
                <h5><b>{{start}}.2.3.2. 偽造検知イベント <small class="float-right">List of last 50</small></b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">
                      <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</td>
                      <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Category</td>
                      <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Pattern</td>
                      <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Path</td>
                      <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Detected Timestamp</td>
                    </tr>
                    <tr v-for="WF_5_2_3_2 in wsfinder_summary.wf_total_detection" :key="WF_5_2_3_2.index">
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.name}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.type}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.action}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.target}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.created_at | date}}</td>
                    </tr>
                    <tr v-for="WF_5_2_3_2 in wmds_summary.wf_total_detection" :key="WF_5_2_3_2.index">
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.name}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.type}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.action == '-' ? 'change' : WF_5_2_3_2.action}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.target}}</td>
                      <td style="border:1px solid; text-align: center;">{{WF_5_2_3_2.created_at | date}}</td>
                    </tr>
                    <tr style="border:1px solid; text-align: center;"
                      v-if="wsfinder_summary.wf_total_detection.length < 1 && wmds_summary.wf_total_detection.length < 1"
                    >
                      <td style="border:1px solid; text-align: center;">N/A</td>
                      <td style="border:1px solid; text-align: center;">N/A</td>
                      <td style="border:1px solid; text-align: center;">N/A</td>
                      <td style="border:1px solid; text-align: center;">N/A</td>
                      <td collapse="2" style="border:1px solid; text-align: center;">N/A</td>
                    </tr>
                  </tbody>
                </table>
                <!-- WMDS -->
                <div v-for="(WF_5_2_3_3, index) in wmds_summary.wf_events_domain" :key="WF_5_2_3_3.index">
                  <h5><b>{{start}}.2.3.{{index + 3}} 偽造検知イベント ({{WF_5_2_3_3.fqdn}}) <small class="float-right">List of last 10</small></b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                        <tr>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</td>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Type</td>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Action</td>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Target</td>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Detected Timestamp</td>
                        </tr>
                        <tr v-for="WF_5_2_3_3_1 in WF_5_2_3_3.rs_list" :key="WF_5_2_3_3_1.index">
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_3_1.name}}</td>
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_3_1.type}}</td>
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_3_1.action ? 'change' : 'change'}}</td>
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_3_1.target}}</td>
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_3_1.created_at | date}}</td>
                        </tr>
                    </tbody>
                  </table>
                </div>
                <!-- wsfinder -->
                <div v-for="(WF_5_2_3_4, index) in wsfinder_summary.wf_events_server" :key="WF_5_2_3_4.index">
                  <h5><b>{{start}}.2.3.{{wmds_summary.wf_events_domain.length + index + 3}} 偽造検知イベント ({{WF_5_2_3_4.host}}) <small class="float-right">List of last 10</small></b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                        <tr>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Name</td>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Type</td>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Action</td>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Target</td>
                          <td style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Detected Timestamp</td>
                        </tr>
                        <tr v-for="WF_5_2_3_4_1 in WF_5_2_3_4.rs_list" :key="WF_5_2_3_4_1.index">
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_4_1.name}}</td>
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_4_1.type}}</td>
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_4_1.action}}</td>
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_4_1.target}}</td>
                          <td style="border:1px solid; text-align: center;">{{WF_5_2_3_4_1.created_at | date}}</td>
                        </tr>
                        <tr style="border:1px solid; text-align: center;" v-if="WF_5_2_3_4.rs_list.length < 1">
                          <td style="border:1px solid; text-align: center;">N/A</td>
                          <td style="border:1px solid; text-align: center;">N/A</td>
                          <td style="border:1px solid; text-align: center;">N/A</td>
                          <td style="border:1px solid; text-align: center;">N/A</td>
                          <td style="border:1px solid; text-align: center;">N/A</td>
                        </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <h4><b>4.3 Response Status</b></h4>
        <b-row style="padding-left:25px;">
          <b-col>
            <h5><b>4.3.1. Incident Response</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>4.3.1.1. Alert sending status</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th style="border:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%"></th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detection E-mail</th>
                    </tr>
                    <tr>
                      <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">Alert</th>
                      <th style="border:1px solid; background-Color:#f0f3f5; text-align: center;">{{`60`}}</th>
                    </tr>
                  </tbody>
                </table>
                <h5><b>4.3.1.2. Daily detection Alert</b></h5>
                <line-chart :chartData="this.chartData"></line-chart>
              </b-col>
            </b-row>
          </b-col>
        </b-row> -->
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>

// chart
import lineChart from '../../chart/MainChart';
import BarChart from '../../chart/BarChart';
import DoughnutChart from '../../chart/DoughnutChart';
import StackedVerticalBarChart from '../../chart/StackedVerticalBarChart'

// lib
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import _ from 'lodash'
import Custom from '@/f1/service/custom';

export default {
  name:'ReportWebCastle',
  props: [
    'start',
    'end',
    'from',
    'to',
    'wsfinder_summary',
    'wmds_summary',
    'WF_Daily_Detect_Total',
    'WF_Daily_detect_domain',
    'WF_Daily_detect_server',
  ],
  components: {
    // chart
    lineChart,
    DoughnutChart,
    BarChart,
    StackedVerticalBarChart,

  },
  data: () => {
    return {
      custom : Custom.custom_default,
      codes,
      auth,
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    // custom
    get_doughnut_data: function(severity) {
      let doughnut_data = { labels: [], datasets: [ { label: 'Risk analysis', backgroundColor: [], data: [] } ] }
      _.sortBy(severity, s => s.total).forEach(x => {
        doughnut_data.labels.push(codes.WAF_SEVERITY_TO_DESC(x.severity))
        doughnut_data.datasets[0].data.push(x.total)
        doughnut_data.datasets[0].backgroundColor.push(codes.WAF_SEVERITY_TO_COLOR(x.severity))
      })
      return doughnut_data
    },
    // 넘버링
  },
  created: function() {
    console.log(`[${this.custom.slogan}]Report.wfdetect.vue`, `created`);
  },
  destroyed: function() { console.log(`[${this.custom.slogan}]Report.wfdetect.vue`, `destroyed`); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}]Report.wfdetect.vue`, `mounted`);
  },
}
</script>
